/**
 * Here we declare the enums, used only on UI for different purposes across the whole application
 */
export enum RequestStatuses {
    PRISTIN = 'PRISTIN',
    PENDING = 'PENDING',
    SUCCESS = 'SUCCESS',
    FAILURE = 'FAILURE',
}

export enum RequestMethods {
    CREATE = 'CREATE',
    DELETE = 'DELETE',
    UPDATE = 'UPDATE',
}

export enum FilterType {
    Array = 'array',
    DateRange = 'date-range',
    IntegerRange = 'integer-range',
    Range = 'range',
    BooleanSwitch = 'boolean-switch',
}

export enum KeyboardKeys {
    ENTER = 'Enter',
    ESCAPE = 'Escape',
    BACKSPACE = 'Backspace',
    ARROW_LEFT = 'ArrowLeft',
    ARROW_UP = 'ArrowUp',
    ARROW_RIGHT = 'ArrowRight',
    ARROW_DOWN = 'ArrowDown',
    COMMA = ',',
    PERIOD = '.',
    A = 'a',
}

export enum CommonRoutes {
    Slash = '/',
    Asterisk = '*',
    All = 'all',
    Edit = 'edit',
    DataUpdate = 'data-update',
    Overview = 'overview',
    Update = 'update',
    ChangeHistory = 'change-history',
    Excluded = 'excluded',
    Demo = 'demo',
    Index = '',
}

export enum DemoPages {
    DemoActivityRecords = 'activity-records-demo',
    DemoEngagements = 'engagements-demo',
    DemoContacts = 'contacts-demo',
    DemoContractBasis = 'contract-basis-demo',
    DemoServiceCenters = 'service-centers-demo',
    DemoContainersDashboard = 'containers-dashboard-demo',
}

export enum YesNo {
    YES = 'Yes',
    NO = 'No'
}

export enum Availability {
    AVAILABLE = 'Available',
    NOT_AVAILABLE = 'Not Available',
}

export enum ContainerAvailabilityForecastContainerStatuses {
    ToBeProcessed = 'toBeProcessed',
    InProcess = 'inProcess',
    Processed = 'processed',
    InPreconditioning = 'inPreconditioning',
    Preconditioned = 'preconditioned',
}

export enum ContainerAvailabilityForecastIncludeOptions {
    IncludeNotStartedOrders = 'includeNotStartedOrders',
    IncludePreBookings = 'includePreBookings',
    IncludeAllDualContainers = 'includeAllDualContainers',
}

export enum UnassignedToOpportunityError {
    MAX_LENGTH = 'maxLength',
    MATCH = 'match',
    MAX_LENGTH_AND_MATCH = 'maxLengthAndMatch'
}

export enum IconType {
    RedWarning = 'redWarning',
    OrangeWarning = 'orangeWarning'
}

export enum FeesType {
    Lane = 'fees',
    Additional = 'laneIndependentPricingFees',
    OtherFees = 'otherFees',
    LongTermLease = 'longTermLeaseFees',
}

export enum WarningCardVariant {
    Warning = 'warning',
    Error = 'error',
    Critical = 'critical',
    Success = 'success',
}

export enum BatchEntity {
    LOGGER = 'LOGGER',
    LANE_FEES = 'LANE_FEES',
    'FORECAST' = 'FORECAST',
}
